import React from 'react';
// import 'antd/dist/antd.css';
import './assets/styles/global.css';
import './App.less';
import Routes from './routes';

function App() {
  return (
    <Routes />
  );
}

export default App;
